
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../../store/modules/user';
import { getBranchList } from '../../../api/cyclCheck';

@Component({
  name: 'DialogSelectBranch',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  branchVisible!: Boolean;
  @Watch('branchVisible', {
    immediate: true
  })
  toggleVisible(val: boolean) {
    if (val) {
      this.tableData = [];
      this.radioSelected = '';
      this.getList();
    }
  }
  @Prop({
    type: String,
    default: '0'
  })
  companyId!: string;
  private formSearch = {
    name: ''
  };
  private loading = false;
  private tableData = [];
  private radioSelected = '';
  private page = 1;
  private loadMore = false;
  private moreData() {
    this.page = this.page + 1;
    this.getList();
  }
  private getList() {
    this.loading = true;
    let companyid = this.companyId;
    if (parseInt(this.companyId) === 0) {
      companyid = UserModule.getCompanyId;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: companyid,
      name: this.formSearch.name,
      page: this.page,
      size: 10
    };
    getBranchList(params)
      .then((res) => {
        if (res && res.data) {
          if (this.page === 1) {
            this.tableData = res.data.list;
          } else {
            this.tableData = this.tableData.concat(res.data.list);
          }
          if (res.data.page_count > res.data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.loadMore = false;
          this.tableData = [];
        }
        this.loading = false;
      })
      .catch((err) => {
        this.loadMore = false;
        this.loading = false;
        this.tableData = [];
        let msg = (err.msg);
      });
  }

  handleSearch() {
    this.radioSelected = '';
    this.getList();
  }

  handleClear() {
    this.radioSelected = '';
    this.page = 1;
    this.formSearch.name = '';
    this.getList();
  }

  handleSubmit() {
    // 选择客户后点击确定
    if (this.radioSelected === '') {
      this.$notify({
        title: '提示',
        message: '请选择客户',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return;
    }
    this.$emit('selectcus', this.radioSelected);
  }

  private close() {
    this.$emit('close', false);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
